import PropTypes from "prop-types";
import {
  Box, FormControl, MenuItem, Pagination, Paper, Select, Stack, Typography,
} from "@mui/material";

// Barra di paginazione condivisa (stile GestioneEcommerce): selettore righe, badge
// conteggio e controlli di pagina. `children` ospita contenuto extra (es. statistiche).
export default function AdminTablePagination({
  isMobile = false,
  rowsPerPage,
  setRowsPerPage,
  page,
  setPage,
  totalPages,
  countLabel,
  countValue,
  rowsOptions = [10, 20, 30, 50],
  children,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 0,
        p: 2,
        px: 3,
        borderRadius: "20px",
        border: isMobile ? "none" : "1px solid #e2e8f0",
        backgroundColor: isMobile ? "transparent" : "white",
        boxShadow: isMobile ? "none" : "0 16px 28px -16px rgba(15, 23, 42, 0.20)",
      }}
    >
      <Box sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "auto 1fr auto" },
        alignItems: "center",
        gap: 2,
      }}>
        {/* Selettore righe per pagina */}
        <Box display="flex" alignItems="center" gap={1.5} justifyContent={{ xs: "center", md: "flex-start" }} sx={{ minWidth: "fit-content" }}>
          <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>
            Mostra:
          </Typography>
          <FormControl size="small" sx={{ width: 75 }}>
            <Select
              value={rowsPerPage}
              onChange={(e) => { setRowsPerPage(Number.parseInt(e.target.value, 10)); setPage(0); }}
              sx={{
                borderRadius: "12px",
                fontWeight: 700,
                backgroundColor: "#f8fafc",
                fontSize: "0.85rem",
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "transparent" },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1" },
              }}
            >
              {rowsOptions.map((v) => <MenuItem key={v} value={v}>{v}</MenuItem>)}
            </Select>
          </FormControl>
        </Box>

        {/* Badge conteggio totale */}
        <Box display="flex" justifyContent="center" sx={{ width: "100%" }}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              backgroundColor: "#f8fafc",
              px: isMobile ? 2 : 2.5,
              py: isMobile ? 1.5 : 0.75,
              borderRadius: "15px",
              border: "1px solid #e2e8f0",
              boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)",
              whiteSpace: "nowrap",
              width: isMobile ? "90%" : "fit-content",
              mx: "auto",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Box sx={{ width: 8, height: 8, borderRadius: "50%", flexShrink: 0, backgroundColor: "#0b3d87", boxShadow: "0 0 0 3px rgba(11, 61, 135, 0.1)" }} />
              <Typography variant="caption" sx={{ fontWeight: 700, color: "#64748b", fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                {countLabel}:
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 800, color: "#0b3d87" }}>
                {Number(countValue || 0).toLocaleString("it-IT")}
              </Typography>
            </Box>
          </Stack>
        </Box>

        {/* Controlli di pagina */}
        <Box display="flex" justifyContent={{ xs: "center", md: "flex-end" }}>
          <Pagination
            count={totalPages || 1}
            page={page + 1}
            onChange={(e, newPage) => { setPage(newPage - 1); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            color="primary"
            shape="rounded"
            siblingCount={0}
            boundaryCount={1}
            size="small"
            sx={{
              "& .MuiPaginationItem-root": {
                fontWeight: 700,
                borderRadius: "10px",
                fontSize: "0.8rem",
                height: "32px",
                minWidth: "32px",
                "&.Mui-selected": {
                  backgroundColor: "#0b3d87",
                  color: "white",
                  boxShadow: "0 2px 6px rgba(11, 61, 135, 0.15)",
                },
              },
            }}
          />
        </Box>
      </Box>

      {children}
    </Paper>
  );
}

AdminTablePagination.propTypes = {
  isMobile: PropTypes.bool,
  rowsPerPage: PropTypes.number.isRequired,
  setRowsPerPage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  countLabel: PropTypes.string.isRequired,
  countValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rowsOptions: PropTypes.arrayOf(PropTypes.number),
  children: PropTypes.node,
};
 